import { Form } from "@remix-run/react";

import { TimetableSlot, useTimetableContext } from "./Timetable.hooks";

import { Button } from "~/components/Button";
import { usePendingNavigation } from "~/hooks/useShowSpinner";

interface TimeslotLinkProps {
  slot: TimetableSlot;
  className?: string;
  children: React.ReactNode | ((isLoading: boolean) => React.ReactNode);
}

export function TimeslotLink({ children, slot, ...props }: TimeslotLinkProps) {
  const { timeZone } = useTimetableContext();

  const { isLoading, isLoadingForValue } = usePendingNavigation(
    "start",
    slot.data?.start.toAbsoluteString(),
  );

  return (
    <Form className="w-full" method="post">
      <Button {...props} data-component="TimetableSlotLink" isDisabled={isLoading} type="submit">
        {typeof children === "function" ? children(isLoadingForValue) : children}
        <input name="start" type="hidden" value={slot.data?.start.toAbsoluteString()} />
        <input name="end" type="hidden" value={slot.data?.end.toAbsoluteString()} />
        <input name="employeeIds" type="hidden" value={slot.data?.employeeIds.join(",")} />
        <input name="timeZone" type="hidden" value={timeZone} />
      </Button>
    </Form>
  );
}
